import { RiMailLine, RiHeartFill } from "react-icons/ri";
import { NAV_LINKS } from "../data/content";
import logo from "../assets/logo.png";
import "./Footer.css";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">

          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__logo">
              <span className="footer__logo-mark">
                <img src={logo} alt="Our Fathers Our Sons logo" className="footer__logo-img" />
              </span>
              <span className="footer__logo-name">
                <span className="footer__logo-name-primary">Our Fathers Our Sons</span>
                <span className="footer__logo-name-sub">Strengthening Families</span>
              </span>
            </div>
            <p className="footer__tagline">
              Bridging data, lived experience, and policy to strengthen families
              and reduce reoffending.
            </p>
            <div className="footer__socials">
              <a
                href="mailto:info@ourfathersoursons.org"
                className="footer__social-btn"
                aria-label="Email"
              >
                <RiMailLine />
              </a>
            </div>
          </div>

          {/* Nav links */}
          <div className="footer__col">
            <h4 className="footer__col-title">Navigation</h4>
            <ul>
              {NAV_LINKS.map(({ label, id }) => (
                <li key={id}>
                  <button className="footer__link" onClick={() => scrollTo(id)}>
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer__col">
            <h4 className="footer__col-title">Contact</h4>
            <ul>
              <li>
                <a
                  href="mailto:info@ourfathersoursons.org"
                  className="footer__link"
                >
                  info@ourfathersoursons.org
                </a>
              </li>
              <li>
                <button
                  className="footer__book-btn"
href="https://cal.com/schea91/introcall"
                  onClick={() =>
                    window.open("https://cal.com/schea91/introcall", "_blank")
                  }
                >
                  Book a Consultation →
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer__bottom">
          <span>
            © {new Date().getFullYear()} OurFathersOurSons LLC. All rights
            reserved.
          </span>
          <span className="footer__made">
            Made with <RiHeartFill className="footer__heart" /> for communities
            and families
          </span>
        </div>
      </div>
    </footer>
  );
}